// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { stopPropagationOnly } from '../../utils/domUtil';
import { getIsCollapsed } from '../../../common/elements/utils/elementPropertyUtils';

// Analytics
import { sendAmplitudeEvent } from '../../analytics/amplitudeService';
import { EVENT_TYPE_NAMES } from '../../../common/analytics/amplitudeEventTypesUtil';
import { AMPLITUDE_USER_PROPS, TRACKED_FEATURES } from '../../../common/analytics/statsConstants';

// Components
import Icon from '../../components/icons/Icon';

// Styles
import './ColumnCollapseButton.scss';

const ColumnCollapseButton = (props) => {
    const { show, dispatchUpdateElement, elementId, element, isEditable } = props;

    const collapsed = getIsCollapsed(element);

    const onClick = React.useCallback(
        (event) => {
            event.stopPropagation();

            sendAmplitudeEvent({
                eventType: EVENT_TYPE_NAMES.COLLAPSED_COLUMN,
                userProperties: {
                    [AMPLITUDE_USER_PROPS.FEATURE]: { [TRACKED_FEATURES.COLLAPSED_COLUMN]: true },
                },
            });

            dispatchUpdateElement({
                id: elementId,
                changes: {
                    collapsed: !collapsed,
                },
                sync: isEditable,
            });
        },
        [collapsed],
    );

    if (!show) return null;

    return (
        <div className="ColumnCollapseButton" onMouseDown={stopPropagationOnly} onClick={onClick}>
            <Icon name="column-collapse" />
        </div>
    );
};

ColumnCollapseButton.propTypes = {
    show: PropTypes.bool,
    elementId: PropTypes.string,
    element: PropTypes.object,
    isEditable: PropTypes.bool,
    dispatchUpdateElement: PropTypes.func,
};

export default ColumnCollapseButton;
